exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 576px) {\n.w-100-mobile[data-v-f6fc41ae] {\n    width: 100%;\n}\n}\n.gift-promotion[data-v-f6fc41ae] {\n  margin: 0 auto;\n}\n.fs18[data-v-f6fc41ae] {\n  font-size: 18px;\n}\n@media (max-width: 768px) {\n.mtmob[data-v-f6fc41ae] {\n    margin-top: 20px !important;\n}\n}\n", ""]);

// exports
